import { useState, useEffect } from "react";

interface Admin {
  id: string;
  role: string;
  email: string;
  firstName: string;
  lastName: string;
  isActive: true;
  organizationId: string;
  version: number;
  createdAt: string;
  updatedAt: string;
  deletedAt: string;
  lastLoginAt: string;
  organization: {
    id: string;
    name: string;
    address: string;
    registrationNo: string;
    contactEmail: string;
    contactPhone: string;
    subscriptionTier: string;
    subscriptionExpiry: string;
    isActive: boolean;
    isVerified: boolean;
    firstTimePayment: boolean;
    slug: string;
    verificationOtp: string;
    otpGeneratedAt: string;
    representativeName: string;
    representativeEmail: string;
    representativeRole: string;
    companySize: string;
    atsSystem: string;
    challengeDescription: string;
    referralSource: string;
    maxAdmins: number;
    maxInterviews: number;
    currentAdminCount: number;
    monthlyInterviewCount: number;
    version: number;
    paystackCustomerId: string;
    billingEmail: string;
    paymentMethod: string;
    frequency: string;
    createdAt: string;
    updatedAt: string;
    deletedAt: string;
  };
}

interface AuthData {
  token: string;
  admin: Admin;
}

export const useAuth = () => {
  const [authData, setAuthData] = useState<AuthData | null>(null);

  useEffect(() => {
    const storedAdmin = localStorage.getItem("@admin");
    const storedToken = localStorage.getItem("@token");

    if (storedAdmin && storedToken) {
      try {
        const admin = JSON.parse(storedAdmin);
        setAuthData({ admin, token: storedToken });
      } catch (error) {
        console.error("Error parsing stored admin data:", error);
        // Clear invalid data
        localStorage.removeItem("@admin");
        localStorage.removeItem("@token");
      }
    }
  }, []);

  const isSuperAdmin = authData?.admin?.role === "SUPER_ADMIN";
  const isEmail = authData?.admin?.email;
  const isName = authData?.admin?.firstName;
  const isLastName = authData?.admin?.lastName;
  const isOrganizationName = authData?.admin?.organization?.name;
  const isRole = authData?.admin?.role;

  // const isOrgAdmin = authData?.admin?.role === "ORG_ADMIN";
  // const isUserAdmin = authData?.admin?.role === "USER_ADMIN";
  // const isUser = authData?.admin?.role === "USER";

  return {
    authData,
    isSuperAdmin,
    isEmail,
    isName,
    isLastName,
    isOrganizationName,
    isRole,
    isAuthenticated: !!authData?.token,
  };
};
